import { format, isToday, isTomorrow } from 'date-fns';

export const getInputWrapperClassList = (
  readOnly: boolean,
  inactive: boolean,
  error: string,
  isDropdownOpen: boolean,
) => {
  const inputWrapperClassList = ['date-select'];
  if (isDropdownOpen) {
    inputWrapperClassList.push('active');
    return inputWrapperClassList.join(' ');
  }

  if (readOnly) {
    inputWrapperClassList.push('read-only');
    return inputWrapperClassList.join(' ');
  }

  if (inactive) {
    inputWrapperClassList.push('inactive');
    return inputWrapperClassList.join(' ');
  }

  if (error) {
    inputWrapperClassList.push('error');
    return inputWrapperClassList.join(' ');
  }

  return inputWrapperClassList.join(' ');
};

export const getInputClassList = (
  placeholder?: string,
  error?: string,
  isDropdownOpen?: boolean,
  inactive?: boolean,
) => {
  const inputClassList = ['date-select-button'];
  if (inactive) inputClassList.push('date-select-button-no-border');
  if (placeholder === '' && error === '') inputClassList.push('active');
  if (isDropdownOpen && !inputClassList.includes('active')) inputClassList.push('active');
  if (error) inputClassList.push('error');
  return inputClassList.join(' ');
};

export const getMonthDays = (month: number, year: number) => {
  const date = new Date(year, month, 1);
  const days = [];
  const firstDayOfWeek = date.getDay();
  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return { days, firstDayOfWeek };
};

export const getEndOfPrevMonth = (day: number, month: number, year: number) => {
  const date = new Date(year, month, day);
  const prevMonthDays = [];
  while (date.getMonth() === month) {
    prevMonthDays.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return prevMonthDays;
};

export const getMonthAndYear = (day: number, month: number, year: number) => {
  const date = new Date(year, month, day);
  return format(date, 'MMMM yyyy');
};

export const getFormattedDate = (day?: number, month?: number, year?: number) => {
  if (day && month && year) {
    const date = new Date(year, month, day);

    if (isToday(date)) {
      return `Today  ${format(date, 'EEEE do MMMM')}`;
    }

    if (isTomorrow(date)) {
      return `Tomorrow  ${format(date, 'EEEE do MMMM')}`;
    }

    return format(date, 'EEEE do MMMM');
  }
};

export const getExtraDays = (
  days: Date[],
  firstDayOfWeekIndex: number,
  prevMonthDaysCount: number,
) => {
  const dateCount = days.length + firstDayOfWeekIndex;
  let squareCount = days.length;

  if (dateCount === 28) {
    squareCount = 28;
  } else if (dateCount > 28 && dateCount <= 35) {
    squareCount = 35;
  } else if (dateCount > 35 && dateCount <= 42) {
    squareCount = 42;
  }

  return squareCount - (days[days.length - 1].getDate() + prevMonthDaysCount);
};
